module.exports = {
	"pagination": {
		"ListCertificates": {
			"limit_key": "MaxItems",
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "CertificateSummaryList"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/acm-2015-12-08.paginators.json
 ** module id = 1255
 ** module chunks = 0
 **/